/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ramesh Kumar | Senior Product Engineer & AI-Driven Leader",
  description:
    "Senior software engineer with 11+ years of experience building scalable mobile, web, and AI-enabled products using GitHub Copilot, Claude, ChatGPT, Cursor, React Native, Flutter, and modern cloud platforms.",
  og: {
    title: "Ramesh Kumar | Senior Product Engineer & AI-Driven Leader",
    type: "website",
    url: "",
  },
};

//Home Page
const greeting = {
  title: "Ramesh Kumar",
  logo_name: "RameshKumar",
  nickname: "Senior Product Engineer • 11+ Years • AI-First Builder",
  subTitle:
    "I design and ship high-impact mobile & web products using modern engineering practices and AI-assisted workflows. 11+ years of hands-on experience building scalable systems, leading teams, and delivering products that perform reliably at scale. I also support digital brand positioning for KRN Tech and career-focused consultancy growth through MCR Consultancy.",
  resumeLink:
    "https://drive.google.com/file/d/1FL_wydnPF2SWCdw2goYAgZ1KKBx8TpcD/view?usp=sharing",
  portfolio_repository: "https://github.com/RameshSain",
  githubProfile: "https://github.com/RameshSain",
  aiStack: [
    "GitHub Copilot",
    "Claude",
    "ChatGPT",
    "Cursor",
    "Gemini",
    "AWS",
    "React Native",
    "Flutter",
    "Figma",
  ],
  heroStats: [
    { value: "11+", label: "Years Experience" },
    { value: "50+", label: "Products Shipped" },
    { value: "AI", label: "Workflow Expert" },
    { value: "Team", label: "Leadership" },
  ],
};


const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/RameshSain",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ramesh-kumar-147b3249/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:ramesh.tureworrior@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Twitter",
  //   link: "https://twitter.com/ashutosh_1919",
  //   fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
  //   backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  // },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Leadership & Product Execution",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Lead cross-functional teams with focus on quality, speed, and clear ownership.",
        "⚡ Turn product goals into engineering execution that delivers on time.",
        "⚡ Build scalable systems with strong technical foundations and team growth."
      ],
      softwareSkills: [
        { skillName: "Leadership", fontAwesomeClassname: "simple-icons:react", style: { color: "#4F46E5" } },
        { skillName: "Product", fontAwesomeClassname: "simple-icons:javascript", style: { color: "#F59E0B" } },
        { skillName: "Agile", fontAwesomeClassname: "simple-icons:docker", style: { color: "#0EA5E9" } }
      ]
    },
    {
      title: "React Native & Mobile Engineering",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Build production-grade iOS & Android apps with React Native, Flutter, and Swift.",
        "⚡ Ship fast with strong architectural patterns, performance optimization, and release readiness.",
        "⚡ Deep expertise in debugging, app stability, and app-store launches at scale."
      ],
      softwareSkills: [
        { skillName: "React Native", fontAwesomeClassname: "simple-icons:react", style: { color: "#61DAFB" } },
        { skillName: "Flutter", fontAwesomeClassname: "simple-icons:flutter", style: { color: "#02569B" } },
        { skillName: "Swift", fontAwesomeClassname: "simple-icons:swift", style: { color: "#F05138" } }
      ]
    },
    {
      title: "AI-Driven Product Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Accelerate development with GitHub Copilot, Claude, ChatGPT, and AI-first tooling.",
        "⚡ Ship features faster with AI workflows—cleaner code, smarter prototyping, better iteration.",
        "⚡ Help teams adopt AI without compromising quality, maintainability, or code standards."
      ],
      softwareSkills: [
        { skillName: "GitHub Copilot", fontAwesomeClassname: "simple-icons:github", style: { color: "#181717" } },
        { skillName: "Claude", fontAwesomeClassname: "simple-icons:openai", style: { color: "#10B981" } },
        { skillName: "ChatGPT", fontAwesomeClassname: "simple-icons:openai", style: { color: "#10B981" } }
      ]
    },
    {
      title: "Cloud, Infra & Product Delivery",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Design production infrastructure on AWS, Firebase, and cloud platforms.",
        "⚡ Own end-to-end delivery: secure deployments, CI/CD, monitoring, and app-store launches.",
        "⚡ Build scalable backends that support reliable product growth at any scale."
      ],
      softwareSkills: [
        { skillName: "AWS", fontAwesomeClassname: "simple-icons:amazonaws", style: { color: "#FF9900" } },
        { skillName: "Firebase", fontAwesomeClassname: "simple-icons:firebase", style: { color: "#FFCA28" } },
        { skillName: "Docker", fontAwesomeClassname: "simple-icons:docker", style: { color: "#1488C6" } }
      ]
    }
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Rajasthan Technical University ",
      subtitle: "B.Tech. in Computer Science",
      logo_path: "rtu.png",
      alt_name: "RTU Kota",
      duration: "2011-2015",
      descriptions: [
        "⚡ Strong foundation in Data Structures, Algorithms, DBMS, OS, and AI. Covered essential software engineering principles that shaped my approach to scalable system design.",
        "⚡ Proficiency in Java, JavaScript, Cloud Computing, and Mobile Development. These skills laid the groundwork for 11+ years of production engineering work.",
        
      ],
      website_link: "https://www.rtu.ac.in/",
    },
  
  ],
};

const certifications = {
  certifications: [
  //   {
  //     title: "Machine Learning",
  //     subtitle: "- Andrew Ng",
  //     logo_path: "stanford_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
  //     alt_name: "Stanford University",
  //     color_code: "#8C151599",
  //   },
  //   {
  //     title: "Deep Learning",
  //     subtitle: "- Andrew Ng",
  //     logo_path: "deeplearning_ai_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
  //     alt_name: "deeplearning.ai",
  //     color_code: "#00000099",
  //   },
  //   {
  //     title: "ML on GCP",
  //     subtitle: "- GCP Training",
  //     logo_path: "google_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
  //     alt_name: "Google",
  //     color_code: "#0C9D5899",
  //   },
  //   {
  //     title: "Data Science",
  //     subtitle: "- Alex Aklson",
  //     logo_path: "ibm_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
  //     alt_name: "IBM",
  //     color_code: "#1F70C199",
  //   },
  //   {
  //     title: "Big Data",
  //     subtitle: "- Kim Akers",
  //     logo_path: "microsoft_logo.png",
  //     certificate_link:
  //       "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
  //     alt_name: "Microsoft",
  //     color_code: "#D83B0199",
  //   },
  //   {
  //     title: "Advanced Data Science",
  //     subtitle: "- Romeo Kienzler",
  //     logo_path: "ibm_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
  //     alt_name: "IBM",
  //     color_code: "#1F70C199",
  //   },
  //   {
  //     title: "Advanced ML on GCP",
  //     subtitle: "- GCP Training",
  //     logo_path: "google_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
  //     alt_name: "Google",
  //     color_code: "#0C9D5899",
  //   },
  //   {
  //     title: "DL on Tensorflow",
  //     subtitle: "- Laurence Moroney",
  //     logo_path: "deeplearning_ai_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
  //     alt_name: "deeplearning.ai",
  //     color_code: "#00000099",
  //   },
  //   {
  //     title: "Fullstack Development",
  //     subtitle: "- Jogesh Muppala",
  //     logo_path: "coursera_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
  //     alt_name: "Coursera",
  //     color_code: "#2A73CC",
  //   },
  //   {
  //     title: "Kuberenetes on GCP",
  //     subtitle: "- Qwiklabs",
  //     logo_path: "gcp_logo.png",
  //     certificate_link:
  //       "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
  //     alt_name: "GCP",
  //     color_code: "#4285F499",
  //   },
  //   {
  //     title: "Cryptography",
  //     subtitle: "- Saurabh Mukhopadhyay",
  //     logo_path: "nptel_logo.png",
  //     certificate_link:
  //       "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
  //     alt_name: "NPTEL",
  //     color_code: "#FFBB0099",
  //   },
  //   {
  //     title: "Cloud Architecture",
  //     subtitle: "- Qwiklabs",
  //     logo_path: "gcp_logo.png",
  //     certificate_link:
  //       "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
  //     alt_name: "GCP",
  //     color_code: "#4285F499",
  //   },
   ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "11+ years of product engineering and mobile leadership",
  description:
    "I’ve spent more than a decade building mobile and web products, leading engineering execution, and delivering features that matter. From early-stage execution to mature product delivery, I focus on building clean systems, strong user experiences, and dependable engineering outcomes.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Placeholder — New Experience",
          company: "Confidential Org",
          company_url: "#",
          logo_path: "portfolio.gif",
          duration: "2025 - Present",
          location: "Remote",
          description: "Brief description about this role. Replace with actual details.",
          color: "#10B981",
        },
                {
                  title: "Senior Product Engineer (Confidential)",
                  company: "Confidential - Private Venture",
                  company_url: "#",
                  logo_path: "portfolio.gif",
                  duration: "2024 - 2025",
                  location: "Remote",
                  description:
                    "Led AI-powered product development with focus on scalability, performance, and market delivery. Drove full-stack engineering decisions across mobile and backend systems.",
                  color: "#6366f1",
                },
        {
          title: "Lead React Native Engineer",
          company: "Orange Mantra",
          company_url: "https://www.orangemantra.com/",
          logo_path: "om.png",
          duration: "2021 - 2024",
          location: "Gurugram, India",
          description:
            "Lead product engineering and team growth. Ship mobile features with strong technical foundation and mentorship focus.",
          color: "green",
        },
        {
          title: "React Native Developer",
          company: "Semidot Infotech",
          company_url: "https://semidotinfotech.com/",
          logo_path: "semidot.png",
          duration: "2018 - 2021",
          location: "Jaipur, India",
          description:
            "Shipped 10+ production apps. Focused on quality, performance, and release readiness across iOS and Android.",
          color: "#fc1f20",
        },
        {
          title: "React Native Developer",
          company: "Qwork Solutions",
          company_url: "https://mobile.twitter.com/qworksolutions",
          logo_path: "qw.png",
          duration: "2017 - 2018",
          location: "Jaipur, India",
          description:
            "Owned delivery and quality for mobile apps in client-driven projects. Debug, optimize, and ship reliably.",
          color: "#fc1f20",
        },
        {
          title: "iOS App Developer",
          company: "iSol Systems Pvt. Ltd",
          company_url: "https://www.isol.co.in/",
          logo_path: "isol.png",
          duration: "2016 - 2017",
          location: "Jaipur, India",
          description:
            "Shipped iOS apps with strong stakeholder alignment. Focused on requirements clarity and quality delivery.",
          color: "#9b1578",
        },
        {
          title: "Mobile App Developer",
          company: "Aryavart Infotech",
          company_url: "https://www.aryausa.com/",
          logo_path: "logo.png",
          duration: "2015 - 2016",
          location: "Jaipur, India",
          description:
            "Built early mobile experiences with focus on product fundamentals, design thinking, and technical core.",
          color: "#0879bf",
        }
      ]
    }
  ]
};

const projectsHeader = {
  title: "Projects",
  description:
    "Product-ready mobile apps and web solutions. Built with React Native, Flutter, Swift, and modern tooling.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Insights",
  description:
    "Technical writing on mobile development, engineering practices, and real-world product delivery.",
  avatar_image_path: "projects_image.svg",
};

const contactPageData = {
  contactSection: {
    title: "Let’s build a stronger digital presence",
    profile_image_path: "ramesh.png",
    description:
      "I help businesses shape tech-led digital identity, career-focused training programs, and portfolio experiences that convert interest into trust and action.",
  },  serviceOfferings: [
    {
      title: "*** Company Profile",
      description: "A professional technology company identity built for leads, clients, and hiring partners. Designed to communicate trust, capability, and business value clearly.",
      price_range: "Lead Ready",
      icon: "🏢",
      scope: ["Brand positioning", "Technology profile", "Lead-focused messaging", "Business credibility"]
    },
    {
      title: "*** Consultancy",
      description: "Career-focused technology training and guidance that helps people build future-ready skills, growth plans, and job-ready confidence in the digital industry.",
      price_range: "Consulting",
      icon: "🎓",
      scope: ["Career guidance", "Tech skill training", "Future-ready roadmap", "Professional growth coaching"]
    },
    {
      title: "Portfolio & Digital Presence",
      description: "A polished online portfolio that showcases experience, capability, and value to clients, recruiters, and business leads in a clear and conversion-ready way.",
      price_range: "Portfolio",
      icon: "💼",
      scope: ["Portfolio design", "Personal branding", "Lead capture", "Professional credibility"]
    },
    {
      title: "Technical Consulting & Support",
      description: "Architecture review, performance optimization, team mentoring, and strategic technical guidance for growing digital businesses.",
      price_range: "Request Quote",
      icon: "💡",
      scope: ["Code review & architecture", "Performance audit", "Team mentoring", "Strategic guidance"]
    }
  ],
  quotesSection: {
    title: "Request a Quote",
    subtitle: "Get a custom quote for your project, digital brand, or consultancy requirement.",
    cta_text: "Request Quote",
    email: "ramesh.tureworrior@gmail.com",
    services: ["*** Company Profile", "*** Consultancy", "Portfolio & Digital Presence", "Technical Consulting"]
  },  blogSection: {
    title: "Writing",
    subtitle:
      "Engineering and product lessons from 11+ years of shipping mobile and web products.",
    link: "https://www.linkedin.com/in/ramesh-kumar-147b3249/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Location",
    subtitle: "Jodhpur, Rajasthan, India",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/82ysgoVzyZ4RwjRV6",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+91-8946803729",
  },
};

const publications = {
  data: [
    {
      id: "1",
      name: "Swift Dependency Injection",
      createdAt: "2020-03-06T16:26:54Z",
      description: "A practical breakdown of dependency injection in Swift for cleaner app architecture.",
      url: "https://medium.com/@rameshsainom/swift-dependency-injection-863ba00f60fb",
    },
    {
      id: "2",
      name: "Flutter VelocityX",
      createdAt: "2022-04-06T16:26:54Z",
      description: "A quick look at using VelocityX to build faster UI workflows in Flutter.",
      url: "https://medium.com/@rameshsainom/flutter-velocity-x-a82b2cc0539f",
    },
    {
      id: "3",
      name: "React Native in Practice",
      createdAt: "2021-05-06T16:26:54Z",
      description: "Hands-on guidance on release quality, architecture, and real-world product delivery.",
      url: "https://medium.com/@rameshsainom/how-to-deploy-react-native-apps-using-docker-dde9b9cbd2aa",
    },
  ],
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
